import { render, staticRenderFns } from "./content-text.vue?vue&type=template&id=e855bc86&scoped=true&lang=html"
import script from "./content-text.vue?vue&type=script&lang=js"
export * from "./content-text.vue?vue&type=script&lang=js"
import style0 from "./content-text.vue?vue&type=style&index=0&id=e855bc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e855bc86",
  null
  
)

export default component.exports